export default __webpack_public_path__ + "static/media/a.e91ac0cf.png";